<ng-template #chartBackground>
  <div class="chart-background">
    <div *ngFor="let row of chartBackgroundYLabels" class="chart-background-row"></div>
  </div>
</ng-template>
<ng-template #chartGroup let-group="group">
  <div class="chart-group">
    <div class="chart-group-content">
      <ng-container *ngIf="type === 'separateCheckouts'">
        <div
          class="chart-bar"
          *ngFor="let bar of group.checkouts"
          [style.height.%]="bar.barPercent"
          [style.background-color]="bar.color"
          data-toggle="tooltip"
          [title]="bar.title"
        ></div>
      </ng-container>
      <ng-container *ngIf="type === 'mergedCheckout'">
        <div
          class="chart-stacked-bar"
          [style.height.%]="group.stackedPercentSum"
          data-toggle="tooltip"
          [title]="group.title"
        >
          <div
            class="chart-bar"
            *ngFor="let bar of group.checkouts"
            [style.height.%]="bar.stackedPercent"
            [style.background-color]="bar.color"
          ></div>
        </div>
      </ng-container>
    </div>
    <div class="chart-group-label">
      {{ group.dateLabel }}
    </div>
  </div>
</ng-template>

<div class="w-100">
  <loading-spinner [isLoading]="isLoading" [classesString]="'top-50'"></loading-spinner>
  <div class="chart-container" [ngClass]="{ 'd-none': isNoDataForChart }">
    <div class="chart-legend-left">
      <div *ngFor="let row of chartBackgroundYLabels" class="chart-legend-left-row">{{ row }}</div>
    </div>
    <div #chartElement [id]="chartId" class="chart" [style.height.px]="415">
      <ng-container [ngTemplateOutlet]="chartBackground"></ng-container>
      <div class="chart-content" #chartContentEl>
        <ng-template ngFor let-group [ngForOf]="chartData">
          <ng-container [ngTemplateOutlet]="chartGroup" [ngTemplateOutletContext]="{ group: group }"></ng-container>
        </ng-template>
      </div>
    </div>
    <div class="chart-legend-right">
      <div *ngFor="let checkoutLegend of checkoutLegend" class="checkout-legend-row">
        <div class="checkout-legend-square" [style.background-color]="checkoutLegend.color"></div>
        <div>
          {{ checkoutLegend.name?.length ? (checkoutLegend.name | shortStr: 10) : ('stats.deductions' | translate) }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isNoDataForChart" class="text-center m-3">{{ 'chart.noDataFor' | translate }} {{ type | translate }}</div>
</div>
